<template>
  {{ translation }}
</template>

<script>

import {useStore} from "@/store";
import { ref, computed, watch } from 'vue';

export default {
  name: 'Translation',
  props: {
    en: {
      type: String,
      required: false
    },
    ch: {
      type: String,
      required: false
    }
  },
  setup(props) {
    const userStore = useStore();

    const translation = ref('');

    const currentLanguage = computed(() => userStore.user_data.language);

    const updateTranslation = () => {
      if (currentLanguage.value === 'zh_CN') {
        translation.value = props.ch;
      } else {
        translation.value = props.en;
      }
    };

    watch(currentLanguage, updateTranslation, { immediate: true });

    return {
      translation
    };
  }
}

</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";



</style>
